import { create } from 'zustand';

import { IVA } from '@/shared/interfaces';
import {  GetIvasParams, getIvas } from '@/shared/actions/erp';

interface IvaStore {
  ivas: IVA[];

  isLoadingIva: boolean;

  getIva: (params?: GetIvasParams) => Promise<void>;
}

export const useIvaStore = create<IvaStore>(set => ({
  ivas: [],

  isLoadingIva: false,

  getIva: async params => {
    set({ isLoadingIva: true });

    const { data } = await getIvas(params);
    set({ ivas: data.data });

    set({ isLoadingIva: false });
  },
}));
